import { render, staticRenderFns } from "./UploadHealthChecklist.vue?vue&type=template&id=8d3e5f86&scoped=true&"
import script from "./UploadHealthChecklist.vue?vue&type=script&lang=js&"
export * from "./UploadHealthChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3e5f86",
  null
  
)

export default component.exports